<template>
  <div>
    <a-descriptions bordered :size="'small'">
      <a-descriptions-item v-if="payrollInfo.pay_num01" :label="payrollInfo.pay_num01">
        {{payrollInfo.pay_val01}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num02" :label="payrollInfo.pay_num02">
        {{payrollInfo.pay_val02}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num03" :label="payrollInfo.pay_num03">
        {{payrollInfo.pay_val03}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num04" :label="payrollInfo.pay_num04">
        {{payrollInfo.pay_val04}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num05" :label="payrollInfo.pay_num05">
        {{payrollInfo.pay_val05}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num06" :label="payrollInfo.pay_num06">
        {{payrollInfo.pay_val06}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num07" :label="payrollInfo.pay_num07">
        {{payrollInfo.pay_val07}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num08" :label="payrollInfo.pay_num08">
        {{payrollInfo.pay_val08}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num09" :label="payrollInfo.pay_num09">
        {{payrollInfo.pay_val09}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num10" :label="payrollInfo.pay_num10">
        {{payrollInfo.pay_val10}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num11" :label="payrollInfo.pay_num11">
        {{payrollInfo.pay_val11}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_dat01" :label="payrollInfo.pay_dat01">
        {{payrollInfo.pay_val12}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_dat02" :label="payrollInfo.pay_dat02">
        {{payrollInfo.pay_val13}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_dat03" :label="payrollInfo.pay_dat03">
        {{payrollInfo.pay_val14}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_car01" :label="payrollInfo.pay_car01">
        {{payrollInfo.pay_val15}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_car02" :label="payrollInfo.pay_car02">
        {{payrollInfo.pay_val16}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num17" :label="payrollInfo.pay_num17">
        {{payrollInfo.pay_val17}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num18" :label="payrollInfo.pay_num18">
        {{payrollInfo.pay_val18}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num19" :label="payrollInfo.pay_num19">
        {{payrollInfo.pay_val19}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num20" :label="payrollInfo.pay_num20">
        {{payrollInfo.pay_val20}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num21" :label="payrollInfo.pay_num21">
        {{payrollInfo.pay_val21}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num22" :label="payrollInfo.pay_num22">
        {{payrollInfo.pay_val22}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num23" :label="payrollInfo.pay_num23">
        {{payrollInfo.pay_val23}}
      </a-descriptions-item>
      <a-descriptions-item v-if="payrollInfo.pay_num24" :label="payrollInfo.pay_num24">
        {{payrollInfo.pay_val24}}
      </a-descriptions-item>
    </a-descriptions>
    <br>
    <br>
    <br>
  </div>
</template>
<script>
  export default {
    props: ['payrollInfo'],
    data () {
      return {}
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/PayrollDetailsCer.vue